import React from 'react';
import { connect } from 'react-redux';
import querystring from 'query-string';
import { Row } from 'antd';
import { BaseStore } from 'src/store';

import {
  LayoutDynamicZone,
  LayoutPageHeading,
  LayoutCardSize,
  LayoutCardType,
} from 'src/modules/layout';
import { LayoutDynamicZoneComponentTypes } from 'src/modules/layout/components/dynamicZone/LayoutDynamicZone';
import LayoutPage from 'src/modules/layout/components/page/LayoutPage';
import { useIntl } from 'react-intl';
import { PagesStore, PageEntity, PageKeys } from 'src/modules/pages';
import { useLocale } from 'src/modules/locale';
import { getCurrentUrlParams } from 'src/utils/url';
import { defaultHorizontalGutter } from 'src/utils/grid';

export enum NewsletterPageTypes {
  Register = 'Register',
  Subscribe = 'Subscribe',
  Unsubscribe = 'Unsubscribe',
  Preferences = 'Preferences',
}
interface PagesNewsletterProps extends PagesStore {
  page?: PageEntity;
  newsletterPage?: NewsletterPageTypes;
}

const PagesNewsletter: React.FunctionComponent<PagesNewsletterProps> = (props) => {
  const intl = useIntl();
  const { getLocalizedObject } = useLocale();

  const { page, newsletterPage = NewsletterPageTypes.Subscribe } = getLocalizedObject(props);
  const { dynamic_content } = page || {};
  const { error } = querystring.parse(getCurrentUrlParams());
  let titleKey, sublineKey, pageProperties;
  //Subscribe page
  if (newsletterPage === NewsletterPageTypes.Subscribe) {
    pageProperties = {
      title: intl.formatMessage({ id: 'page/newsletter/subscribe/head/title' }),
      description: intl.formatMessage({ id: 'page/newsletter/subscribe/head/description' }),
      noIndex: true,
    };
    //Check if errors coming from newsletter redirect
    if (error) {
      titleKey = 'page/newsletter/subscribe/error/title';
      sublineKey = 'page/newsletter/subscribe/error/subline';
    } else {
      titleKey = 'page/newsletter/subscribe/success/title';
      sublineKey = 'page/newsletter/subscribe/success/subline';
    }
  }

  // Unsubscribe page
  else if (newsletterPage === NewsletterPageTypes.Unsubscribe) {
    pageProperties = {
      title: intl.formatMessage({ id: 'page/newsletter/unsubscribe/head/title' }),
      description: intl.formatMessage({ id: 'page/newsletter/unsubscribe/head/description' }),
    };
    //Check if errors coming from newsletter redirect
    if (error) {
      titleKey = 'page/newsletter/unsubscribe/error/title';
      sublineKey = 'page/newsletter/unsubscribe/error/subline';
    } else {
      titleKey = 'page/newsletter/unsubscribe/success/title';
      sublineKey = 'page/newsletter/unsubscribe/success/subline';
    }
  }
  // Preferences page
  else if (newsletterPage === NewsletterPageTypes.Preferences) {
    pageProperties = {
      title: intl.formatMessage({ id: 'page/newsletter/preferences/head/title' }),
      description: intl.formatMessage({ id: 'page/newsletter/preferences/head/description' }),
    };
    //Check if errors coming from newsletter redirect
    if (error) {
      titleKey = 'page/newsletter/preferences/error/title';
      sublineKey = 'page/newsletter/preferences/error/subline';
    } else {
      titleKey = 'page/newsletter/preferences/success/title';
      sublineKey = 'page/newsletter/preferences/success/subline';
    }
  }
  return (
    <LayoutPage {...pageProperties}>
      <LayoutPageHeading titleKey={titleKey} sublineKey={sublineKey} />
      {dynamic_content && (
        <Row gutter={[defaultHorizontalGutter, 0]}>
          <LayoutDynamicZone
            filter={LayoutDynamicZoneComponentTypes.Card}
            size={LayoutCardSize.Small}
            type={LayoutCardType.Overview}
            components={dynamic_content}
            groupCards={false}
          />
        </Row>
      )}
    </LayoutPage>
  );
};

const mapStateToProps = (state: BaseStore) => {
  return {
    page: state.pages.pages[PageKeys.Newsletter],
    ...state.pages,
  };
};
export default connect(mapStateToProps)(PagesNewsletter);
